import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../api/authApi';
import { AuthContext } from '../context/authContext';

const LoginPage = () => {
  const navigator = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const { setUser } = useContext(AuthContext);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const data = await loginUser(email, password);
      localStorage.setItem('token', data.token);
      setUser({ token: data.token, userData: data.user });
      navigator('/');
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <div className="tgme_page auth_page">
      <div className="tgme_page_wrap">
        <h3>Войдите в свой аккаунт</h3>
        <form onSubmit={handleLogin}>
          <div>
            <label>Email:</label>
            <input
              placeholder="Введите почту"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label>Пароль:</label>
            <input
              placeholder="Введите пароль"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {message && <p>{message}</p>}
          <button type="submit">Войти</button>
        </form>
        <span onClick={() => navigator('/auth/register')}>
          У вас ещё нет аккаунта? Зарегистрируйтесь!
        </span>
      </div>
    </div>
  );
};

export default LoginPage;
